import React from 'react';
import {ActNature} from "../Shared/Enums/Enums";
import {t} from "../I18n/i18n"


function StatusIcon({status, act}) {

    if (status === -1) {
        return <i className="material-icons grey-text white" title={t("EXAM_HISTORY.EXAM_NOT_COVER")}>do_not_disturb_on</i>
    }
    else if (status === 0) {
        return <i className="material-icons grey-text white" title={t("EXAM_HISTORY.NOT_TRANSMITTED")}>cancel</i>
    }
    else if (status === 1) {
        // Unhandled case
        if ((!act || (act.prix === 0 && act.nature !== ActNature.NURSE.name && act.titre!=="AREA"))) {
            return <i className="material-icons grey-text white" title={t("EXAM_HISTORY.NOT_TRANSMITTED")}>cancel</i>
        }
        if (act && ![ActNature.TELEMEDICAL.name, ActNature.NURSE.name].includes(act.nature)) {
            return <i className="material-icons green-text text-darken-1 white" style={{borderRadius: 20, marginBlock: 5}} title={t("EXAM_HISTORY.EXAM_PERFORMED")}>check_circle</i>
        }
        return <i className="material-icons orange-text white" title={t("EXAM_HISTORY.VALIDATION_IN_PROGRESS")}>more_time</i>
    }
    else if (status === 2) {
        return <i className="material-icons green-text text-darken-1 white" title={t("EXAM_HISTORY.VALIDATED_PRESCRIPTION")}>check_circle</i>
    }
    else if (status === 3) {
        return <i className="material-icons red-text white" title={t("EXAM_HISTORY.ALERT")}>report_problem</i>
    }
    else {
        return null
    }
}

export default StatusIcon;